import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Map } from './components/Map';
import { AccommodationList } from './components/AccommodationList';
import { accommodations, poiCategories } from './data/mockData';
import { MenuIcon, XIcon } from 'lucide-react';
import { useUserProfile, poiRelevanceByPartyType } from './context/UserProfileContext';
export function App() {
  const {
    selectedPOIs,
    setSelectedPOIs,
    travelParty
  } = useUserProfile();
  const [hoveredAccommodation, setHoveredAccommodation] = useState<number | null>(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Automatically update POIs when travel party changes
  useEffect(() => {
    const relevantPOIs = poiRelevanceByPartyType[travelParty];
    setSelectedPOIs(relevantPOIs);
  }, [travelParty, setSelectedPOIs]);
  const togglePOI = (poiType: string) => {
    setSelectedPOIs(prev => prev.includes(poiType) ? prev.filter(p => p !== poiType) : [...prev, poiType]);
  };
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <div className="relative flex flex-col md:flex-row w-full flex-1" data-id="element-2">
        {/* Map (shown first on all devices) */}
        <div className="w-full md:w-1/2 h-[calc(100vh-64px)] order-1" data-id="element-3">
          <Map accommodations={accommodations} selectedPOIs={selectedPOIs} poiCategories={poiCategories} togglePOI={togglePOI} hoveredAccommodation={hoveredAccommodation} sidebarOpen={sidebarOpen} data-id="element-4" />
        </div>
        {/* Mobile/Tablet Sidebar Toggle Button */}
        <button onClick={toggleSidebar} className="md:hidden fixed bottom-6 left-6 z-[1001] bg-white p-3 rounded-full shadow-lg" data-id="element-5">
          {sidebarOpen ? <XIcon size={24} className="text-rose-500" data-id="element-6" /> : <MenuIcon size={24} className="text-rose-500" data-id="element-7" />}
        </button>
        {/* Accommodation List - Sidebar on mobile/tablet, normal view on desktop */}
        <div className={`
            w-full md:w-1/2 
            overflow-y-auto 
            md:h-[calc(100vh-64px)] 
            md:static 
            fixed 
            top-[64px] 
            left-0 
            h-[calc(100vh-64px)] 
            bg-white 
            z-[1000] 
            transition-transform duration-300 ease-in-out
            md:translate-x-0
            ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
            order-2 md:order-2
          `} data-id="element-8">
          <div className="p-4" data-id="element-9">
            <AccommodationList accommodations={accommodations} onHover={setHoveredAccommodation} selectedPOIs={selectedPOIs} poiCategories={poiCategories} data-id="element-10" />
          </div>
        </div>
      </div>
    </div>;
}